import React, { useState, useEffect, useRef } from 'react';
import './DataEthics.css';
import { TbScanEye, TbFingerprintScan  } from "react-icons/tb";
import { RiSwordFill } from "react-icons/ri";
import { BsGlobe } from "react-icons/bs";
import { IoSearchCircleSharp } from "react-icons/io5";
import { FaHandSpock , FaFlask, FaFilm, FaArrowAltCircleLeft   } from "react-icons/fa";
import { IoPeopleCircle } from "react-icons/io5";
import { collection, query, where, orderBy, onSnapshot, addDoc, serverTimestamp, doc, getDocs, getDoc, setDoc, updateDoc, arrayUnion} from 'firebase/firestore';
import { db, auth } from '../../Firebase_Config/firebase';
import { NavLink } from "react-router-dom";




const toolsData = {
  EthicsEssentials: {
    title: 'Data Ethics Essentials – ODI Learning:',
    content: [
      `
      <p>Our exclusive Data Ethics Essentials taster content is designed to ignite your passion for ethical data practices—all at no charge!</p>
      <p>Further paid courses are available for those of you wanting take a much deeper-dive</p>`
    ],
    link: 'https://learning.theodi.org/courses/data-ethics-essentials',
    buttonText:'Start Learning',
    accentClass: 'card-accent'
  },
  ScienceEthics: {
    title: 'Data Science Ethics – University of Michigan (Coursera):',
    content: [
      `<p>Explores ethical and privacy implications of collecting and managing big data.</p>
      <p>What you'll learn</p>
      <ul>
        <li>Examine the ethical and privacy implications of collecting and managing big data.</li>
        <li>Explore the broader impact of the data science field on modern society.</li>
        <li>Understand who owns data, how we value privacy, how to receive informed consent and what it means to be fair.</li>
      </ul>
      `
      
    ],
    buttonText:'Start Learning',
    link: 'https://www.coursera.org/learn/data-science-ethics',
    accentClass: 'card-accent alt'
  },
  PraticalEthics: {
    title: 'Practical Data Ethics – fast.ai:',
    content: [
        `<p>Focuses on real-world topics like disinformation and bias, providing practical tools for data ethics</p>`
    ],
    buttonText:'Start Learning',
    link: 'https://ethics.fast.ai/',
    accentClass: 'card-accent alt2'
  },
  Video1: {
    title: `Data Ethics 101_ Navigating AI's Moral`,   
    source: '/Videos/DataEthics101.webm',
    accentClass: 'card-accent alt3',
    commentsDoc: 'comments_DataEthics101'
  },
  Video2: {
    title: `AI Ethics`,   
    source: '/Videos/AiEthics.webm',
    accentClass: 'card-accent alt4',
    commentsDoc: 'comments_AIEthics'
  },
};


const DataEthics = () => {
    const getUserId = () => {
    const user = auth.currentUser;
    return user.uid;
  };
    const CommentsSection = ({ commentsDoc }) => {
    const [comment, setComment] = useState("");
    const [comments, setComments] = useState([]);
    const [userName, setUserName] = useState("");
  
    useEffect(() => {
  
      const fetchSectorNameAndScores = async () => {
              try {
                  const userId = getUserId();
                  console.log('User ID:', userId); // Add this line for debugging     
                  const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
                  const userDocSnapshot = await getDocs(userDocQuery);     
                  if (!userDocSnapshot.empty) {                      
                      const userDocData = userDocSnapshot.docs[0].data();                  
                      const UserName =userDocData.Name ||0;
                      setUserName(UserName)                        
                  } else {
                      console.log('User document not found for user ID:', userId);
                  }                  
                    } catch (error) {
                        console.error('Error fetching document:', error);
                    }
          };      
          fetchSectorNameAndScores();

          const commentsDocRef = doc(db,"comments", commentsDoc);

          const unsubscribe = onSnapshot(commentsDocRef, (docSnap) => {
            if (docSnap.exists()) {
              const data = docSnap.data();
              setComments(data.messages || []);
            } else {
              // If the document doesn't exist yet, create it
              setDoc(commentsDocRef, { messages: [] });
            }
          });
  
      return () => unsubscribe();
    }, []);
  
    const handlePostComment = async () => {
      const trimmed = comment.trim();
      if (!trimmed) return;
  
      const user = auth.currentUser;
      if (!user) return;
  
      const newComment = {
        text: trimmed,
        author: userName,
        uid: user.uid,
        timestamp: new Date().toISOString(),
      };
  
      const commentsDocRef = doc(db, "comments",  commentsDoc);
  
      try {
        await updateDoc(commentsDocRef, {
          messages: arrayUnion(newComment),
        });
        setComment("");
      } catch (error) {
        console.error("Error posting comment:", error);
      }
    };
  
    return (
      <div style={{  margin: "auto" }}>
        <h2>Comments</h2>
        <div>
          <input
                  className="form_input"
                  type="text"
                  id="comment"
                  name="comment"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  placeholder="Add a comment..."
                />
          <button className='full-width-button' onClick={handlePostComment} >
            Comment
          </button>
        </div>
        <div style={{ marginBottom: "1rem" }}>
          {comments
            .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
            .map((c, index) => (
              <div
                key={index}
                style={{ borderBottom: "1px solid #ccc", padding: "1rem 0" }}
              >
                <strong>{c.author}</strong>
                <p>{c.text}</p>
                <div style={{ fontSize: "0.8em", color: "gray" }}>
                  {new Date(c.timestamp).toLocaleString()}
                </div>
              </div>
            ))}
        </div>
        {/*<textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows={3}
          placeholder="Leave a comment..."
          style={{ width: "100%", padding: "0.5rem" }}
        />*/}
       
      </div>
    );
  };

    const [selectedTool, setSelectedTool] = useState('EthicsEssentials');
    const renderCard = () => {
      const tool = toolsData[selectedTool];

      if (selectedTool === 'Video1' || selectedTool === 'Video2') {
      return (
        <div className='Network-card'>
            <div className={tool.accentClass} />
            <div className="Netprofessional-card">
                <div className="card-body">
                <h2 className="card-title">{tool.title}</h2>
                <div className='trainPP'>
                    <video autoPlay controls key={tool.source}>
                    <source src={tool.source} type="video/webm" />
                    </video>
                </div>
                <CommentsSection commentsDoc={tool.commentsDoc} />
                </div>
            </div>
        </div>
      );
    }
      return (
        <div className='Network-card'>
          <div className={tool.accentClass} />
          <div className="Netprofessional-card">
            <div className="card-body">
              <h2 className="card-title">{tool.title}</h2>
              {tool.content.map((paragraph, idx) => (
                <div dangerouslySetInnerHTML={{ __html: tool.content }} ></div>
              ))}
              <a href={tool.link} target="_blank" rel="noopener noreferrer" className="full-width-button">
                {tool.buttonText}
              </a>
            </div>
          </div>
        </div>
      );
    };



  return (
    <div className='backgroundHelp'>
      <div className="InternetHyContent">
        <div className='bannerBG'>
          <img src="../banner.png" alt="banner2" className='banner-image' />
        </div>
        <h1 className="helptitle bigger">Data Ethics</h1>
        <div className='BasicGrid'>
          <div className='BasicGrid2'>
             <NavLink to="/Support" >
                <button className="navButtons">
                <div>
                    <FaArrowAltCircleLeft className="helpicons" />
                </div>
                <span>Back</span>
                </button>
            </NavLink>
            <button className="navButtons" onClick={() => setSelectedTool('EthicsEssentials')}>
              <div>
                <IoPeopleCircle className="helpicons" />
              </div>
              <span>Data Ethics Essentials</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('ScienceEthics')}>
              <div>
                <FaFlask className="helpicons" />
              </div>
              <span>Data Science Ethics</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('PraticalEthics')}>
              <div>
                <FaHandSpock className="helpicons" />
              </div>
              <span>Practical Data Ethics</span>
            </button>
            <button className="navButtons" onClick={() => setSelectedTool('Video1')}>
              <div>
                <FaFilm className="helpicons" />
              </div>
              <span>Data Ethics 101</span>
            </button>
             <button className="navButtons" onClick={() => setSelectedTool('Video2')}>
              <div>
                <FaFilm className="helpicons" />
              </div>
              <span>AI Ethics</span>
            </button>
          </div>      
        </div>
        <br/>
        <div className="help-hrLine" />
        <br/>
        {renderCard()}   
      </div>
    </div>
  );
};

export default DataEthics;
